import React from 'react'
import AssetGeneralDetails from '../AssetGeneralDetails'
import AssetImage from '../AssetImage'
import AssetLocation from '../AssetLocation'
// import AssetNotes from '../AssetNotes'
import PropTypes from 'prop-types'
import useFleet from '../../../../hooks/useFleet'
import useRequest from '../../../../hooks/useRequest'
import useGlobalLoading from '../../../../hooks/useGlobalLoading'
import useAuth from '../../../../hooks/useAuth'

const Overview = ({
    assetInfo,
    onGetAssetInfo,
    cords,
    assetImage,
    setAssetImage,
}) => {
    const { handleUpdateAsset } = useFleet()
    const { changeLoading } = useGlobalLoading()
    const { changeNeedsUpdate } = useRequest()

    const { user } = useAuth()

    const onSubmitAssetSucces = () => {
        changeLoading(false)
        changeNeedsUpdate({ dashboard: true, request: true })
        if (onGetAssetInfo) {
            onGetAssetInfo()
        }
    }

    const onSubmitAssetError = () => {
        changeLoading(false)
        console.log('Error')
    }

    const onSave = (newData, onSuccess, fromForm, onError) => {
        const { customer_alias, notes, photoId } = newData
        let additionalDetails = ''
        if (customer_alias) {
            const assetName = assetInfo?.customerAlias
                ? assetInfo?.customerAlias
                : assetInfo?.name
            additionalDetails =
                'Requesting to change Customer Unit Number from ' +
                assetName +
                ' to ' +
                customer_alias
        }
        const userName = user.first_name + ' ' + user.last_name
        const requestData = {
            abcIndicator: 'C',
            additionalDetails: additionalDetails,
            class: assetInfo?.simpleType,
            customerUnitNumber: customer_alias
                ? customer_alias
                : assetInfo?.customerAlias,
            fuelType: assetInfo?.fuelType,
            installedProduct: assetInfo?.salesforceID,
            manufacturer: assetInfo?.manufacturer,
            model: assetInfo?.model,
            serialNumber: assetInfo?.serialLotNumber,
            shipToId: assetInfo?.shipto?.external_id,
            soldToId: assetInfo?.soldToSalesforceID,
            origin: 'LiftOne Now',
            requestType: 'Update',
            user: {
                name: userName,
            },
            notes: notes ? notes : assetInfo?.notes,
            photoId: photoId || '',
            fromForm: fromForm,
        }
        changeLoading(true)
        return handleUpdateAsset(
            requestData,
            resp => {
                onSubmitAssetSucces(resp)
                onSuccess && onSuccess()
            },
            resp => {
                onSubmitAssetError(resp)
                onError && onError(resp)
            },
        )
    }

    return (
        <div className="flex-grow w-full h-full flex flex-col items-start justify-start gap-y-6">
            <div className="flex lg:flex-row flex-col items-center justify-between gap-6 w-full">
                <div className="flex-grow w-full h-79">
                    <AssetImage
                        onSave={onSave}
                        assetImage={assetImage}
                        setAssetImage={setAssetImage}
                    />
                </div>
                <div className="flex-grow w-full h-79">
                    <AssetLocation
                        cords={cords}
                        assetEquipment={assetInfo?.equipmentNumber}
                        location={assetInfo?.location}
                        address={assetInfo?.address}
                    />
                </div>
            </div>

            <div className="w-full h-auto">
                <AssetGeneralDetails assetInfo={assetInfo} onSave={onSave} />
            </div>

            {/* Leaving this commented just in case */}
            {/* <div className="w-full h-auto">
                <AssetNotes notes={assetInfo?.notes} onSave={onSave} />
            </div> */}
        </div>
    )
}

Overview.propTypes = {
    assetInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
    onGetAssetInfo: PropTypes.func.isRequired,
    cords: PropTypes.oneOfType([PropTypes.any, PropTypes.object]),
    assetImage: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
    setAssetImage: PropTypes.func,
}

export default Overview
